import script from "./UiBarListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiBarListCard.vue?vue&type=script&setup=true&lang=js"

import "./UiBarListCard.vue?vue&type=style&index=0&id=a3bf06f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3bf06f8"]])

export default __exports__